import { LoadResourcePlaceList } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

type Params = {
  searchText?: string
}

export class RemoteLoadResourcePlaceList implements LoadResourcePlaceList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadResourcePlaceList.Response>
  ) {}

  async load(params?: Params): Promise<LoadResourcePlaceList.Model[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        q: params?.searchText
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadResourcePlaceList {
  export type ResourcePlace = {
    id: number
    name: string
    hierarchy_latitude?: string
    hierarchy_longitude?: string
    created_at: string
    updated_at: string
  }
  export type Response = {
    results: ResourcePlace[]
  }
}

const formatResponse = (resource_places: RemoteLoadResourcePlaceList.Response): LoadResourcePlaceList.Model[] => {
  return resource_places?.results.map(resource_place => ({
    id: resource_place.id,
    name: resource_place.name,
    hierarchyLatitude: resource_place.hierarchy_latitude,
    hierarchyLongitude: resource_place.hierarchy_longitude,
    createdAt: resource_place.created_at,
    updatedAt: resource_place.updated_at,
  })) || []
}
